import { Grid } from "@mui/material";
import ImageList from "../ImageList";
import Info from "../Info";
import Map from "../Map";
import Title from "../Title";
import { useRTL } from "../../hooks/useLanguage/useRTL";
import { useContent } from "../../content/useContent";
import { directoryCategoriesAr } from "../../utils/translations";
import { translator } from "../../utils/translations/translator";

type IProps = {
  directory: any;
};

const Single: React.FC<IProps> = ({ directory }) => {
  const { isRTL } = useRTL();
  const { directories } = useContent().pages;
  return (
    <>
      <Title title={`${directories.title} - ${directory.name}`} />
      <Grid container>
        <Grid item xs={12} md={6}>
          <Info
            title={directories.category}
            description={
              isRTL
                ? translator(directory.category, directoryCategoriesAr)
                : directory.category
            }
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info title={directories.address} description={directory.address || "-"} />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info
            title={directories.openingHours}
            description={directory.openingHours || "-"}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info
            title={directories.comingSoon}
            description={
              directory.comingSoon ? directories.yes : directories.no
            }
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info
            title={directories.status}
            description={
              directory.status
                ? directories.available
                : directories.notAvailable
            }
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info
            title={directories.reservable}
            description={
              directory.reservable
                ? directories.available
                : directories.notAvailable
            }
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info
            title={directories.partnerCode}
            description={directory.partnerCode || "-"}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info
            title={directories.loyaltyCategory}
            description={directory.loyaltyCategory}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info
            title={directories.website}
            description={directory.website || "-"}
            isLink={!!directory.website}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info
            title={directories.phone}
            description={directory.phone || "-"}
            isLink={!!directory.phone}
            linkTitle={`${directories.call} ${directory.phone}`}
            isTel
            sameTab
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <Info title={directories.meta} description={directory.meta || "-"} />
        </Grid>

        <Grid item xs={12}>
          <Info title={directories.directoryLocation} />
        </Grid>
        <Grid item xs={12}>
          <Map
            center={{ lat: directory.latitude, lng: directory.longitude }}
            zoom={10}
            sx={{ height: "400px" }}
            draggable={false}
            markers={[
              {
                pos: { lat: directory.latitude, lng: directory.longitude },
              },
            ]}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info title={directories.lat} description={directory.latitude} />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info title={directories.lng} description={directory.longitude} />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info title={directories.poi} isLink={!!directory.POI} description={directory.POI || "-"} />
        </Grid>

        <Grid item xs={12}>
          <Info title={directories.images} />
          <ImageList images={directory.images} />
        </Grid>

        <Grid item xs={12}>
          <Info title={directories.logo} />
          <ImageList images={[directory.logo]} />
        </Grid>
      </Grid>
    </>
  );
};

export default Single;
